var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "cover-descriptions",
        {
          "llp-experiment": !!_vm.isInLLPNuxRecsExperiment,
          mobile: _vm.isMobile(_vm.$mq)
        }
      ]
    },
    [
      _c("p", { staticClass: "description" }, [
        _vm._v(_vm._s(_vm.course.intro_text))
      ]),
      _vm._v(" "),
      _vm._t("sub-description"),
      _vm._v(" "),
      _c("div", { staticClass: "stats" }, [
        _c("div", { staticClass: "stat" }, [
          _c("img", {
            staticClass: "stat-image",
            attrs: {
              src: "/site_media/version-0/images/course-page/lessons.svg",
              alt: "Book"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.lessons) + " Lessons")])
        ]),
        _vm._v(" "),
        _vm.hasPractice
          ? _c("div", { staticClass: "stat" }, [
              _c("img", {
                staticClass: "stat-image",
                attrs: {
                  src: "/site_media/version-0/images/course-page/practice.svg",
                  alt: "Dumbbell"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Practice")])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.course.collaborators.length
        ? _c("div", { staticClass: "collaborators-container" }, [
            _c("h3", { staticClass: "title" }, [
              _vm._v("Made in collaboration with")
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "collaborators" },
              _vm._l(_vm.course.collaborators, function(collaborator) {
                return _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "collaborator",
                      attrs: { href: collaborator.link, target: "_blank" }
                    },
                    [
                      _c("BriocheBackgroundImage", {
                        staticClass: "collaborator-image",
                        attrs: { src: collaborator.image, width: 24 }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(collaborator.name))])
                    ],
                    1
                  )
                ])
              }),
              0
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }